// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login_container{width:40vw;height:45vh;min-width:500px;background:#fff;box-shadow:0 0 7px 5px hsla(0,0%,90.2%,.5);border-radius:20px;margin-top:150px;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-left:30vw}", ""]);
// Exports
module.exports = exports;
